import { createSingleEntityStore, type PickActions } from '@core/ngrx-legacy';
import type { ChatMessage } from '@core/tellent-assistant-types';

export interface CurrentThreadMessages {
  threadId: string;
  messages: ChatMessage[];
}

const { selectors, reducer, actions, namespace } =
  createSingleEntityStore<CurrentThreadMessages | null>()('TellentAssistantCurrentThread', {
    customActions: adapter => ({
      fetch: (state, _payload: { threadId: string }) => adapter.markAsPending(state),
      clear: () => adapter.reset(),
    }),
  });

const TellentAssistantCurrentThreadActions: PickActions<typeof actions, 'fetch'> &
  Pick<typeof actions, 'clear'> = actions;

export {
  selectors as TellentAssistantCurrentThreadSelectors,
  reducer as TellentAssistantCurrentThreadReducer,
  TellentAssistantCurrentThreadActions,
  namespace as TellentAssistantCurrentThreadNamespace,
};
